import { render, staticRenderFns } from "./CustomQuote.vue?vue&type=template&id=79076d42&scoped=true"
import script from "./CustomQuote.vue?vue&type=script&lang=js"
export * from "./CustomQuote.vue?vue&type=script&lang=js"
import style0 from "./CustomQuote.vue?vue&type=style&index=0&id=79076d42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79076d42",
  null
  
)

export default component.exports